module.exports = __webpack_public_path__ + "static/media/stephanieLongboard.2598c86e.png";